export const PERMS = {
    READ: 'report_vehicle_traffic.read',
    UPDATE: 'report_vehicle_traffic.update',
    DELETE: 'report_vehicle_traffic.delete',
    CREATE: 'report_vehicle_traffic.create',
    EXPORT: 'report_vehicle_traffic.export',
}
